module.exports = __webpack_public_path__ + "img/lazada.ef62a33b.svg";